import { render, staticRenderFns } from "./monitoring.vue?vue&type=template&id=3af59745&scoped=true&"
import script from "./monitoring.vue?vue&type=script&lang=js&"
export * from "./monitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af59745",
  null
  
)

export default component.exports